module.exports = __webpack_public_path__ + "static/img/ic_o_s_fo.271207d7.svg";